import styles from './SidebarProfile.module.css';
import { useGetProfileQuery } from '../store/api/profileApi';
import { useGetFollowCountQuery } from '../store/api/followApi';
import {
  FaEnvelope,
  FaUserTag,
  FaMapMarkerAlt,
  FaHeart,
  FaTag
} from "react-icons/fa";
import ImagePreview from "../components/common/ImagePreview";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Link } from "react-router-dom";

export default function SidebarProfile() {
  const { data: user, isLoading: loading, error } = useGetProfileQuery();
  const navigate = useNavigate();
  const [showAllFields, setShowAllFields] = useState(false);
  const currentUserId =
    useSelector((state) => state.auth.userId) ||
    localStorage.getItem("userId");

  const { data: followCount } = useGetFollowCountQuery(currentUserId);

  if (loading) {
    return (
      <div className={styles.container}>
        <p>Loading profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <p className={styles.error}>
          {error.data?.message || error.error || "Something went wrong"}
        </p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className={styles.container}>
        <p>No user data</p>
      </div>
    );
  }

  const followers = followCount?.followers ?? 0;
  const following = followCount?.following ?? 0;

  const location =
    [user.city, user.state].filter(Boolean).join(", ") || "N/A";

  const handleFollowersClick = () => {
    navigate(`/profile/${currentUserId}/followers`);
  };

  const handleFollowingClick = () => {
    navigate(`/profile/${currentUserId}/following`);
  };

    const initials = user.name
    ?.split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
   
    const interestedFieldsArray = user.interestedFields
  ? user.interestedFields.split(',').map(f => f.trim())
  : [];

  const visibleFields = showAllFields
  ? interestedFieldsArray
  : interestedFieldsArray.slice(0, 3);

const extraCount = interestedFieldsArray.length - 3;

  return (
    <div className={styles.sidebar}>
      
      {/* Profile Image */}
      <div className={styles.profilePhoto}>
        {user?.profilePhotoUrl ? (
        <ImagePreview
          src={
            user.profilePhotoUrl 
          }
          alt={user?.name || 'User'}
          className={styles.profileImage}
        /> ) : (
            <div className={styles.noPhoto}>{initials || '?'}</div>
          )}
      </div>

      {/* Name */}

<h2 className={styles.name}>
  <Link to="/profile" className={styles.profileLink}>
    {user.name}
  </Link>
</h2>

      {/* Followers / Following */}
      <div className={styles.stats}>
        <div
          className={styles.statItem}
          onClick={handleFollowersClick}
        >
          <span className={styles.statNumber}>{followers}</span>
          <span className={styles.statLabel}>Followers</span>
        </div>

        <div
          className={styles.statItem}
          onClick={handleFollowingClick}
        >
          <span className={styles.statNumber}>{following}</span>
          <span className={styles.statLabel}>Following</span>
        </div>
      </div>

      {/* Details */}
      <div className={styles.details}>
        <div className={styles.detailItem}>
          <FaEnvelope className={styles.icon} />
          <span>{user.email}</span>
        </div>

        <div className={styles.detailItem}>
          <FaUserTag className={styles.icon} />
          <span>{user.userType || 'N/A'}
            {user.userType === 'Rookie' && user.rookieType
              ? ` (${user.rookieType})`
              : ''}</span>
        </div>

        <div className={styles.detailItem}>
          <FaMapMarkerAlt className={styles.icon} />
          <span>{location}</span>
        </div>

        <div className={styles.detailItem}>
  <FaTag className={styles.icon} />

  {interestedFieldsArray.length > 0 ? (
    <div className={styles.tagContainer}>
      {visibleFields.map((field, index) => (
        <span key={index} className={styles.tag}>
          {field}
        </span>
      ))}

      {!showAllFields && extraCount > 0 && (
        <span
          className={styles.moreTag}
          onClick={() => setShowAllFields(true)}
        >
          +{extraCount}
        </span>
      )}

      {showAllFields && interestedFieldsArray.length > 3 && (
        <span
          className={styles.moreTag}
          onClick={() => setShowAllFields(false)}
        >
          Show less
        </span>
      )}
    </div>
  ) : (
    <span>N/A</span>
  )}
</div>
      </div>
    </div>
  );
}